import script from "./MaskLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./MaskLayer.vue?vue&type=script&setup=true&lang=js"

import "./MaskLayer.vue?vue&type=style&index=0&id=978b85d0&lang=scss&scoped=true"
script.__scopeId = "data-v-978b85d0"

export default script